module.exports = __webpack_public_path__ + "fonts/fa-v4compatibility.da94ef4.ttf";